<template>
    <div>
        <h5 class="mb-3">
            <strong>Ces 7 derniers jours</strong>, avez-vous eu des problèmes (courbatures, douleurs, gênes,
            engourdissements...) au niveau des zones du corps suivants ?
        </h5>
        <section v-if="isLoaded && isLoadedEdit">
            <div class="evaluationItem my-4" v-for="(part, key) in bodyParts" :key="key">
                <div class="evaluationItem__container">
                    <div class="evaluationItem__container__img">
                        <img :src="'/static/img/nordic/' + key + '.png'" :alt="key"/>
                    </div>
                    <div class="evaluationItem__container__content">
                        <strong>{{ part }}</strong>
                    </div>
                    <div class="evaluationItem__container__actions d-flex align-items-center">
                        <div v-if="form.hasWeek[key]" class="mr-2">
                            <output :style="{borderColor: colors[form.douleursWeek[key]] }">
                                {{ form.douleursWeek[key] }}
                            </output>
                        </div>
                        <div>
                            <SwitchExtended
                                    :value="form.hasWeek[key] === undefined ? null : form.hasWeek[key]"
                                    @input="input({$event, key})" invert class="mx-2"
                            />
                        </div>
                    </div>
                </div>
                <div class="evaluationItem__subcontainer container--dark" v-if="form.hasWeek[key] === true">
                    <p class="mb-2">Votre niveau de douleur [0-10] ?</p>
                    <TouchRange :min="0" :max="10" :step="1" v-model="form.douleursWeek[key]" class="range w-100"
                                @input="change()"
                    />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import SwitchExtended from "../../SwitchExtended";
    import TouchRange from "../../TouchRange";

    export default {
        name: 'evaluation-nordique-week',
        components: {TouchRange, SwitchExtended},
        props: {
            pains: Object
        },
        data: () => ({
            isLoaded: false,
            isLoadedEdit: false,
            form: {
                hasYear: {},
                hasWeek: {},
                douleursWeek: {}
            }
        }),
        mounted() {
            this.isLoaded = false;
            this.form = this.pains;
            this.isLoaded = true;
            this.isLoadedEdit = true;
        },
        methods: {
            input({$event, key}) {
                if (this.isLoaded && this.form.hasWeek[key] !== $event) {
                    this.$set(this.form.hasWeek, key, $event)
                    if ($event && this.form.douleursWeek[key] !== $event) {
                        this.$set(this.form.douleursWeek, key, 0)
                    }
                    this.change();
                }
            },
            change() {
                if (this.isLoaded) {
                    this.isLoadedEdit = false;
                    this.$emit('change', {data: this.form})
                    this.isLoadedEdit = true;
                }
            }
        },
        computed: {
            bodyParts() {
                return this.$store.getters['base/evaluation/nordic/bodyParts']
            },
            colors() {
                return this.$store.getters['base/evaluation/nordic/colors']
            }
        }
    }
</script>
